var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multiple-bubble-container"},_vm._l((_vm.expectedResponseChoices),function(response){return _c('vv-checkbox-bubble',{key:response,attrs:{"label":_vm.choices[response].label,"disabled":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }